import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=033bf703&scoped=true&"
import script from "./EditVideo.vue?vue&type=script&lang=js&"
export * from "./EditVideo.vue?vue&type=script&lang=js&"
import style0 from "./EditVideo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditVideo.vue?vue&type=style&index=1&id=033bf703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033bf703",
  null
  
)

export default component.exports